


































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'

import userList from '@/store/entities/userinfo'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';
class Packed {
    inputSackNums: number = 0;
    inputBaseSkuNums: number = 0;
    warehouseReMark: string;
}
@Component
export default class EditLogisticsModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    selectuser: userList = new userList();
    user: Array<userList> = [];
    automaticJump: boolean;
    PackedModel: Packed = new Packed();

    created() {
        this.get();
    }
    async get() {

        this.user = await this.$store.dispatch({
            type: 'user/getUserList',
            data: {}
        });
        if (this.user.length > 0) {
            var data = this.user.filter(function (item) { return item.id == abp.session.userId });
            if (data.length > 0) {
                this.selectuser.id = data[0].id;
            }
            //  this.selectuser.id = this.user[0].id;
        }

    }

    async save() {
        var id = this.$store.state.backstockorder.id;
        await this.$store.dispatch({
            type: 'backstockorder/stockOrderBale',
            data: { id: id, SackNums: this.PackedModel.inputSackNums, BaseSkuNums: this.PackedModel.inputBaseSkuNums, packedUserId: this.selectuser.id, WarehouseReMark: this.PackedModel.warehouseReMark }
        });
        
        (this.$refs.packForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }


    cancel() {
        (this.$refs.packForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {

        if (!value) {
            this.$emit('input', value);
        } else {
            this.PackedModel.inputBaseSkuNums = this.$store.state.backstockorder.BaseSkuNums;
        }
    }
}
